import React, { useEffect } from 'react';
import SectionTop from '../components/SectionTop';
import { useDispatch } from 'react-redux';
import PromotionCodePosts from '../components/PromotionCodePosts';
import HighlightPosts from '../components/HighlightPosts';
import ApplicationPosts from '../components/ApplicationPosts';
import { fetchHomePageData } from '../redux/actions';

const HomePage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchHomePageData.sendHomePageRequest());
  }, [dispatch]);

  return (
    <div style={{ width: '90%', margin: 'auto' }}>
      <SectionTop></SectionTop>
      <PromotionCodePosts />
      <HighlightPosts />
      <ApplicationPosts />
    </div>
  )
}

export default HomePage;